if (!customElements.get('product-policy-container')) {
  class ProductPolicyContainer extends HTMLElement {
    constructor() {
      super();
      this.policyBoxes = this.querySelectorAll('.t4s-policy-box');
    }

    connectedCallback() {
      this.policyBoxes.forEach((policyBox) => {
        const policyHeader = policyBox.querySelector('.t4s-policy-header');
        if (policyHeader) {
          policyHeader.addEventListener('click', () => {
            const policyButton = policyHeader.querySelector('.t4s-policy-header-button');
            if (policyButton) {
              policyButton.classList.toggle('active');
            }
            const policyContent = policyHeader.nextElementSibling;
            if (policyContent && policyContent.classList.contains('t4s-policy-content')) {
              $(policyContent).slideToggle();
            }
          });
        }
      });
    }
  }
  customElements.define('product-policy-container', ProductPolicyContainer);
}

if (!customElements.get('product-description')) {
  class ProductDescription extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      document.querySelectorAll('.rte table').forEach(function (table) {
        if (!table.parentElement.classList.contains('table-wrapper'))
          table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + '</div>';
      });
    }
  }
  customElements.define('product-description', ProductDescription);
}
